import React from 'react';

const Pilots = () => {
    return (
        <div className='App'>Pilots</div>
    );
}

export default Pilots;